import type { Entity } from "@backstage/catalog-model";

import {
    GCP_PROJECT_ANNOTATION_ALIASES,
    GCP_PROJECT_ANNOTATION_PRIMARY,
} from "./constants";

/**
 * Returns true when the entity has at least one GCP project annotation,
 * making it eligible for the Cloud Findings tab.
 *
 * Checks the primary annotation first, then each alias in order.
 *
 * @param entity - The catalog entity to inspect.
 */
export function isGcpSecurityFindingsAvailable(entity: Entity): boolean {
    const annotations = entity.metadata.annotations;
    return Boolean(
        annotations?.[GCP_PROJECT_ANNOTATION_PRIMARY] ??
            annotations?.[GCP_PROJECT_ANNOTATION_ALIASES[0]] ??
            annotations?.[GCP_PROJECT_ANNOTATION_ALIASES[1]]
    );
}
